export default __webpack_public_path__ + "static/media/arrowRight.b0d05e93.webp";